import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProblemserviceService {
  private apiUrl = environment.baseUrl + environment.problemstatement;
  private apiUrl1 = environment.baseUrl + environment.problemid;
  private problem_statement_upload=environment.baseUrl  + environment.problem_statement_upload;


  constructor(private http: HttpClient) {}

  getProblemstatement(): Observable<any> {
    return this.http.get(this.apiUrl);
  }

  // getProblemById(id: number): Observable<any> {
  //   const url = `${this.apiUrl1}?problem_id=${id}`;
  //   console.log('API URL:', url);
  //   return this.http.get(url);
  // }

  submitProblemStatement(data: any) {
    return this.http.post(
      environment.baseUrl + environment.applyProblemApi,
      data
    );
  }

  tabsProblemData: any = null;
  tabsProblemTabs: any[] = [];
  tabsProblemActiveTab: string = '';

  setState(data: any, tabs: any[], active: string) {
    this.tabsProblemData = data;
    this.tabsProblemTabs = tabs;
    this.tabsProblemActiveTab = active;
  }

  getState() {
    return {
      tabsProblemData: this.tabsProblemData,
      tabsProblemTabs: this.tabsProblemTabs,
      tabsProblemActiveTab: this.tabsProblemActiveTab,
    };
  }
  //  private problemid = environment.problemid;


  getProblemById(id: number) {
    return this.http.get(`${this.apiUrl1}${id}`);
  }

uploadFile(formData: FormData) {
  return this.http.post(
      this.problem_statement_upload,
    formData
  );
}

}
